import ApiClientDocument from './apiClientDocument'
import { useAuthStore } from './authStore'

// Vytvoríme jedinú inštanciu ApiClientDocument pre celú aplikáciu
const apiClientDocument = new ApiClientDocument()

// Pri prvom načítaní aplikácie nastavíme token z `authStore`
const auth = useAuthStore.getState().auth
apiClientDocument.setAuthToken(auth?.token ?? null)

// Počúvame na zmeny v `authStore` a aktualizujeme `apiClientDocument`
useAuthStore.subscribe((state) => {
  apiClientDocument.setAuthToken(state.auth?.token ?? null)
})

/**
 * Hook to get the api instance (Nest /document doc, apiClientDocument).
 * Synchronizuje token zo store pri každom renderi, čím sa vyhne race condition
 * keď hasAuthToken je už true, ale client ešte nemal token.
 */
export function useApiClientDocument() {
  const auth = useAuthStore((state) => state.auth)
  // Sync token pred vrátením - zaručí, že client má token keď ho komponent použije
  apiClientDocument.setAuthToken(auth?.token ?? null)
  return apiClientDocument.apiInstance
}
